import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import PropTypes from "prop-types";

const Sidebar = ({ currentRoute }) => {
  const [subOpen, setSubopen] = useState("");

  // Récupérer le module à partir de la route
  const currentModule = currentRoute.split("/")[1]; // Extrait le premier segment après "/"

  // Filtrer les données en fonction du module courant
  const filteredData = SidebarData.filter((item) => item.module === currentModule);

  const toggleSidebar = (title) => {
    setSubopen(title === subOpen ? "" : title);
  };
  Sidebar.propTypes = {
    currentRoute: PropTypes.string.isRequired, // La route doit être une chaîne de caractères et est obligatoire
  };
  

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredData.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel.label}</h6>
                    <ul>
                      {mainLabel.submenuItems.map((title, i) => (
                        <li
                          className={`submenu ${
                            !title.submenu && currentRoute === title.link
                              ? "custom-active-hassubroute-false"
                              : ""
                          }`}
                          key={i}
                        >
                          <Link
                            to={title.link}
                            onClick={() => toggleSidebar(title.label)}
                            className={`${
                              subOpen === title.label ? "subdrop" : ""
                            } ${
                              title.links?.includes(currentRoute)
                                ? "active"
                                : ""
                            }`}
                          >
                            {title.icon}
                            <span className="custom-active-span">
                              {title.label}
                            </span>
                            {title.submenu && <span className="menu-arrow" />}
                          </Link>
                          {title.submenu && (
                            <ul
                              style={{
                                display:
                                  subOpen === title.label ? "block" : "none",
                              }}
                            >
                              {title.submenuItems.map((item, titleIndex) => (
                                <li
                                  key={titleIndex}
                                  className={`${
                                    item.link === currentRoute ? "active" : ""
                                  }`}
                                >
                                  <Link to={item.link}>{item.label}</Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default Sidebar;
